/* RESPONSIBLE TEAM: team-fin-qa */
import ApplicationSerializer from '../application';

/**
 * Normalizes the /teammate_app/qa/monitors/cx_score_reasons response into records.
 * The API returns { cx_score_reasons: [{ id, label }, ...] }.
 */
export default class CxScoreReasonSerializer extends ApplicationSerializer {
  normalizeArrayResponse(
    store: any,
    primaryModelClass: any,
    payload: any,
    id: any,
    requestType: any,
  ) {
    let reasons: any[] = payload.cx_score_reasons || [];
    let normalized = reasons.map((r: any) => ({ id: r.id, label: r.label }));
    return super.normalizeArrayResponse(store, primaryModelClass, normalized, id, requestType);
  }
}
